import React from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api'
import Loader from '../../../shared/loader'

const AccommodationMap = ({items, coords, viewHotel}) => {

	const { isLoaded, loadError } = useLoadScript({
		googleMapsApiKey: "AIzaSyDgf9M-uSr1dEsyd5a_MGJ-hQWQkGApyf8",
		preventGoogleFontsLoading: false
	})

	const getMapCenter = () => {
		//no location coords, default to the center of the uk
		return coords != undefined && coords ? coords : { lat: 55.3781, lng: 3.4360  };
	}

	const renderMap = () => {
		// wrapping to a function is useful in case you want to access `window.google`
		// to eg. setup options or create latLng object, it won't be available otherwise
		// feel free to render directly if you don't need that

		//render markers
		const bounds = new window.google.maps.LatLngBounds();

		const markers = items.map(hotel => {
			if( hotel.coords != undefined && hotel.coords ) {

				bounds.extend(new window.google.maps.LatLng(hotel.coords.lat, hotel.coords.lng));
				return (
					<Marker
						key={`marker` + hotel.id}
						onClick={() => viewHotel(hotel)}
						position={hotel.coords}
					/>
				)
			}
		})

		return (
			<div style={{position: 'relative'}}>

				<GoogleMap
					options={{zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_CENTER }}}
					mapContainerStyle={{position: 'relative', height: '500px'}}
					zoom={14}
		      center={getMapCenter()}
					onLoad={map => {
						map.fitBounds(bounds);
					}}
		        >
					{markers}
		        </GoogleMap>
			</div>
		)
	}

	if (loadError) {
		return <div>Map cannot be loaded right now, sorry.</div>
	}

	return isLoaded ? renderMap() : <Loader />

}

export default AccommodationMap;
